import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../hooks/reduxHooks";

interface PropsPublicRoutes {
  children: ReactElement;
}

export const PublicRoutes = ({ children }: PropsPublicRoutes) => {
  const { status } = useAppSelector((state) => state.auth);

  return status === "not-authenticated" ? children : <Navigate to="/" />;
};
